"use client";
import { setAuthToken } from "@/store";
import { getFromLocale, setToLocale } from "@/utils";
import { useRouter, useSearchParams } from "next/navigation";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

export default function MainLayout({ children }) {

  const router = useRouter();
  const dispatch = useDispatch();
  const searchParams = useSearchParams();
  const token = searchParams.get("access_token");
  const { authToken } = useSelector((state) => state.auth);
  const prevPath = getFromLocale("prevPathLink");
  if (token ) {
    setToLocale({ key: "access_token", value: token });
    dispatch(setAuthToken(token));
  }
  useEffect(() => {
    if ((authToken ) && !prevPath) {
      router.push("/");
    }
  }, [prevPath, router]);




  return <>{children}</>;
}
